(function () {
  var PHONE_MAP = {
    facebook: { number: '8446448873', display: '844-644-8873' },
    instagram: { number: '8446448873', display: '844-644-8873' },
    ig: { number: '8446448873', display: '844-644-8873' },
    meta: { number: '8446448873', display: '844-644-8873' },
    google: { number: '8446794442', display: '844-679-4442' },
    youtube: { number: '8446794442', display: '844-679-4442' },
    microsoft: { number: '8446797830', display: '844-679-7830' },
    bing: { number: '8446797830', display: '844-679-7830' },
    eltoro: { number: '8444452737', display: '844-445-2737' }
  };
  var DEFAULT_PHONE = { number: '8445897374', display: '844-589-7374' };

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function resolvePhone() {
    var utmSource = new URLSearchParams(window.location.search).get('utm_source');
    var cookieSource = getCookie('TLP_info');
    var source = utmSource || cookieSource;
    if (!source) return DEFAULT_PHONE;
    return PHONE_MAP[source.toLowerCase().trim()] || DEFAULT_PHONE;
  }

  function applyPhone() {
    var phone = resolvePhone();

    document.querySelectorAll('[data-tlp-phone-display]').forEach(function (el) {
      el.textContent = phone.display;
    });

    document.querySelectorAll('[data-tlp-phone-link]').forEach(function (el) {
      el.setAttribute('href', 'tel:' + phone.number);
    });
  }

  window.TLPPhoneRouting = {
    apply: applyPhone,
    resolve: resolvePhone
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPhone);
  } else {
    applyPhone();
  }
})();
